(function () {
  function initFindMySize() {
    
    var root = document;

    var link = root.querySelector('.nfd-size-chart-toggle');
    var recTriggerLabelEl = root.querySelector('[data-rec-trigger-label]');

    var panel = root.querySelector('#nfd-size-chart-panel');
    var closeBtn = panel ? panel.querySelector('.nfd-size-chart-close') : null;
    var preMount = panel ? panel.querySelector('[data-sc-table="pre"]') : null;

    var unitNote = root.querySelector('[data-unit-note]');
    var tol = root.querySelector('[data-tolerance]');
    var unitBtns = root.querySelectorAll('.nfd-unit-btn');

    var recDialog = root.querySelector('#nfd-size-rec-dialog');
    if (!recDialog) return;

    var recInlineMemo = root.querySelector('[data-rec-inline]');
    var recSteps = recDialog.querySelectorAll('[data-rec-step]');
    var recProgressItems = recDialog.querySelectorAll('[data-rec-progress]');
    var recResultWrap = recDialog.querySelector('[data-rec-result-wrap]');
    var recInputEls = recDialog.querySelectorAll('[data-rec-input]');
    var recErrorEls = recDialog.querySelectorAll('[data-rec-error]');
   

    if (!panel || !preMount) return;

    var NFD_SIZE_REC_STORAGE_KEY = 'nfd_size_profile_v1';


    var productTitleEl = root.querySelector('#nfd-size-rec-product-title');
    var productTitle = productTitleEl ? productTitleEl.textContent.trim() : '';

    function getShortProductTitle(title) {
      if (!title) return '';

      var parts = title.split(' - ');
      if (parts.length >= 2) {
        return parts[0] + ' - ' + parts[1];
      }

      return parts[0];
    }
    function splitProductTitle(title) {
  if (!title) return { fit: '', fabric: '' };

  var parts = title.split(' - ').map(function (p) {
    return p.trim();
  });

  return {
    fit: parts[0] || '',
    fabric: parts[1] || ''
  };
}
function normalizeFabricLabel(fabric) {
  var s = String(fabric || '').trim();
  if (!s) return '';

  return s.replace(/\s+/g, ' ');
}
function detectMeasurementMode() {
  var rows = safeJsonParse(panel.getAttribute('data-rows'), []);

  if (NFD_MEASUREMENT_MODES.bottoms.supportCheck(rows)) return NFD_MEASUREMENT_MODES.bottoms;
  if (NFD_MEASUREMENT_MODES.tops.supportCheck(rows)) return NFD_MEASUREMENT_MODES.tops;

  return null;
}

function getCurrentMode() {
  return recState.mode || detectMeasurementMode();
}

function updateModeState() {
  recState.mode = detectMeasurementMode();
  return recState.mode;
}
function updateModeUi() {
  var mode = getCurrentMode();
  if (!mode) return;

  root.querySelectorAll('[data-mode-group]').forEach(function (el) {
    el.hidden = el.getAttribute('data-mode-group') !== mode.key;
  });

  root.querySelectorAll('[data-mode-text]').forEach(function (el) {
    var key = el.getAttribute('data-mode-text');
    if (mode[key]) el.textContent = mode[key];
  });
}

function getRequiredFields() {
  var mode = getCurrentMode();
  return mode ? mode.requiredFields : [];
}

function getOptionalFields() {
  var mode = getCurrentMode();
  return mode ? mode.optionalFields : [];
}

function getCompareLabels() {
  var mode = getCurrentMode();
  return mode ? mode.compareLabels : {};
}

function getReferenceLabel() {
  var mode = getCurrentMode();
  return mode ? mode.referenceLabel : 'your reference garment';
}

function isBottomsMode() {
  return getCurrentMode() && getCurrentMode().key === 'bottoms';
}

function isTopsMode() {
  return getCurrentMode() && getCurrentMode().key === 'tops';
}

    var NFD_MEASUREMENT_MODES = {
  bottoms: {
    key: 'bottoms',
    label: 'Bottoms',
    referenceLabel: 'your jeans',
    triggerSaved: '⊹ Compare',
    triggerNew: '⊹ Find my size',
    introTitle: 'Use a pair of jeans that fit you well.',
    introBody: 'Measure them laid flat and enter all measurements in inches. Takes about 1 minute.',
    requiredTitle: 'Required measurements',
    requiredSub: 'These measurements are required to generate a suggested size.',
    optionalTitle: 'Optional measurements',
    optionalSub: 'Add these for a more precise comparison.',
    noteBox: 'Waist and upper thigh determine the size suggestion. Additional measurements help explain how the suggested size compares to your reference pair.',
    requiredFields: ['waist', 'upperThigh'],
    optionalFields: ['frontRise', 'backRise', 'knee', 'legOpening', 'inseam'],
    rowLabelMap: {
      'waist': 'waist',
      'front rise': 'frontRise',
      'back rise': 'backRise',
      'upper thigh': 'upperThigh',
      'thigh': 'upperThigh',
      'knee': 'knee',
      'leg opening': 'legOpening',
      'inseam': 'inseam'
    },
    compareLabels: {
      frontRise: 'Front rise',
      backRise: 'Back rise',
      knee: 'Knee',
      legOpening: 'Leg opening',
      inseam: 'Inseam'
    },
    supportCheck: function (rows) {
      var hasWaist = false;
      var hasUpperThigh = false;

      rows.forEach(function (row) {
        var rawLabel = normalizeLabel(row && row.label);
        if (rawLabel === 'waist') hasWaist = true;
        if (rawLabel === 'upper thigh' || rawLabel === 'thigh') hasUpperThigh = true;
      });

      return hasWaist && hasUpperThigh;
    }
  },

  tops: {
    key: 'tops',
    label: 'Tops',
    referenceLabel: 'your reference top',
    triggerSaved: '⊹ Compare',
    triggerNew: '⊹ Find my size',
    introTitle: 'Use a shirt or jacket that fits you well.',
    introBody: 'Measure it laid flat and enter all measurements in inches. Takes about 1 minute.',
    requiredTitle: 'Required measurements',
    requiredSub: 'These measurements are required to generate a suggested size.',
    optionalTitle: 'Optional measurements',
    optionalSub: 'Add these for a more precise comparison.',
    noteBox: 'Shoulder, pit to pit, and sleeve length drive the size suggestion. Body length helps explain how the suggested size compares to your reference top.',
    requiredFields: ['shoulder', 'pitToPit', 'sleeveLength'],
    optionalFields: ['bodyLength'],
    rowLabelMap: {
      'shoulder': 'shoulder',
      'pit to pit': 'pitToPit',
      'sleeve length': 'sleeveLength',
      'body length': 'bodyLength',
      'length': 'bodyLength'
    },
    compareLabels: {
      shoulder: 'Shoulder',
      pitToPit: 'Pit to pit',
      sleeveLength: 'Sleeve length',
      bodyLength: 'Body length'
    },
    supportCheck: function (rows) {
      var hasShoulder = false;
      var hasPitToPit = false;

      rows.forEach(function (row) {
        var rawLabel = normalizeLabel(row && row.label);
        if (rawLabel === 'shoulder') hasShoulder = true;
        if (rawLabel === 'pit to pit') hasPitToPit = true;
      });

      return hasShoulder && hasPitToPit;
    }
  }
};

var recState = {
  inputUnit: 'in',
  dataset: [],
  profile: null,
  recommendation: null,
  supported: false,
  mode: null
};

    var state = {
      built: false,
      unit: 'in',
      columns: [],
      rows: []
    };

  function refreshLiveRefs() {
  link = root.querySelector('.nfd-size-chart-toggle');
  recTriggerLabelEl = root.querySelector('[data-rec-trigger-label]');

  panel = root.querySelector('#nfd-size-chart-panel');
  closeBtn = panel ? panel.querySelector('.nfd-size-chart-close') : null;
  preMount = panel ? panel.querySelector('[data-sc-table="pre"]') : null;

  unitNote = root.querySelector('[data-unit-note]');
  tol = root.querySelector('[data-tolerance]');
  unitBtns = root.querySelectorAll('.nfd-unit-btn');

  recDialog = root.querySelector('#nfd-size-rec-dialog');
  recInlineMemo = root.querySelector('[data-rec-inline]');
  recSteps = recDialog ? recDialog.querySelectorAll('[data-rec-step]') : [];
  recProgressItems = recDialog ? recDialog.querySelectorAll('[data-rec-progress]') : [];
  recResultWrap = recDialog ? recDialog.querySelector('[data-rec-result-wrap]') : null;
  recInputEls = recDialog ? recDialog.querySelectorAll('[data-rec-input]') : [];
  recErrorEls = recDialog ? recDialog.querySelectorAll('[data-rec-error]') : [];

}
    function safeJsonParse(value, fallback) {
      try {
        return JSON.parse(value || '[]');
      } catch (e) {
        return fallback;
      }
    }

    function toNumber(v) {
      if (v == null) return null;
      var s = String(v).trim();
      if (!s) return null;
      s = s.replace(/,/g, '');
      var n = Number(s);
      return Number.isFinite(n) ? n : null;
    }

    function roundCm(n) {
      n = Number(n);
      if (!Number.isFinite(n)) return null;
      return Math.round(n * 10) / 10;
    }

    function inchesToCm(n) {
      n = Number(n);
      if (!Number.isFinite(n)) return null;
      return Math.round(n * 2.54 * 10) / 10;
    }

    function cmToInches(n) {
      n = Number(n);
      if (!Number.isFinite(n)) return null;
      return Math.round((n / 2.54) * 100) / 100;
    }

    function normalizeLabel(label) {
      return String(label || '').trim().toLowerCase().replace(/\s+/g, ' ');
    }

    function formatMeasurement(n, unit) {
      if (n == null) return '—';

      var num = Number(n);
      if (!Number.isFinite(num)) return '—';

      if (unit === 'cm') {
        var cm = inchesToCm(num);
        return cm == null ? '—' : String(cm) + ' cm';
      }

      return String(num) + '"';
    }

    function escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }
    function lockPageScroll() {
  document.documentElement.classList.add('nfd-rec-open');
  document.body.classList.add('nfd-rec-open');
}

function unlockPageScroll() {
  document.documentElement.classList.remove('nfd-rec-open');
  document.body.classList.remove('nfd-rec-open');
}


   function updateRecTriggerLabel(hasSavedProfile) {
  var mode = getCurrentMode();
  var text = hasSavedProfile
    ? (mode ? mode.triggerSaved : '⊹ Compare')
    : (mode ? mode.triggerNew : '⊹ Find my size');

  root.querySelectorAll('[data-rec-trigger-label]').forEach(function (el) {
    el.textContent = text;
  });
}

    function chartSupportsRecommendation() {
  return !!updateModeState();
}

    function updateRecommendationVisibility() {
  recState.supported = chartSupportsRecommendation();
  updateModeUi();

  root.querySelectorAll('.nfd-size-rec-toggle').forEach(function (el) {
    el.hidden = !recState.supported;
    el.style.display = recState.supported ? '' : 'none';
  });

  root.querySelectorAll('.nfd-size-tools-inline').forEach(function (wrap) {
    var recBtn = wrap.querySelector('.nfd-size-rec-toggle');
    if (recBtn && !recState.supported) {
      wrap.classList.add('nfd-rec-unsupported');
    } else {
      wrap.classList.remove('nfd-rec-unsupported');
    }
  });

  if (!recState.supported) {
    if (recInlineMemo) {
      recInlineMemo.hidden = true;
      recInlineMemo.innerHTML = '';
    }
    updateRecTriggerLabel(false);
  }
}

    function closeChart() {
  var visibleLink = root.querySelector('.nfd-size-chart-toggle');
  if (visibleLink) {
    visibleLink.setAttribute('aria-expanded', 'false');
  }
  panel.hidden = true;
}

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeChart();
      });
    }

    function setUnit(nextUnit) {
      state.unit = nextUnit;

      unitBtns.forEach(function (b) {
        var is = b.getAttribute('data-unit') === nextUnit;
        b.classList.toggle('is-active', is);
        b.setAttribute('aria-pressed', is ? 'true' : 'false');
      });

      if (unitNote) {
        unitNote.textContent = nextUnit === 'cm'
          ? 'All measurements are in centimeters.'
          : 'All measurements are in inches.';
      }

      if (tol) {
        tol.innerHTML = nextUnit === 'cm'
          ? 'A variance of +/- 1.27cm (0.5&quot;) is within tolerance'
          : 'A variance of +/- 0.5&quot; (1.27cm) is within tolerance';
      }

      if (state.built) {
        var cells = panel.querySelectorAll('td[data-in]');
        cells.forEach(function (td) {
          var inchVal = td.getAttribute('data-in');
          var n = toNumber(inchVal);

          if (!Number.isFinite(n)) {
            td.textContent = '';
            return;
          }

          var cmVal = roundCm(n * 2.54);
          td.textContent = nextUnit === 'cm'
            ? (cmVal == null ? '' : String(cmVal))
            : String(inchVal);
        });
      }

      if (recResultWrap && !recResultWrap.hidden && recState.recommendation) {
  recResultWrap.innerHTML = buildResultHtml(recState.recommendation, 'in');
}
    }

    function openRecDrawer() {
      if (!recDialog) return;

      if (recDialog) {
  recDialog.addEventListener('close', function () {
    unlockPageScroll();
  });
}
document.addEventListener('click', function (e) {
  var closeDrawerBtn = e.target && e.target.closest && e.target.closest('.nfd-size-rec-drawer__close');
  if (closeDrawerBtn) {
    unlockPageScroll();
  }
});

      function open() {
        if (typeof recDialog.show === 'function') {
          recDialog.show();
        } else {
          recDialog.setAttribute('open', '');
        }
      }

      if (window.customElements && window.customElements.get('x-drawer')) {
        open();
      } else if (window.customElements && typeof window.customElements.whenDefined === 'function') {
        window.customElements.whenDefined('x-drawer').then(open);
      } else {
        open();
      }
    }

    function renderTableInto(mountEl, columns, rows) {
      var html = '';
      html += '<div class="nfd-size-chart-scroll">';
      html += '<table class="nfd-size-chart">';
      html += '<thead><tr>';

      for (var i = 0; i < columns.length; i++) {
        html += '<th scope="col">' + String(columns[i] != null ? columns[i] : '') + '</th>';
      }

      html += '</tr></thead><tbody>';

      for (var r = 0; r < rows.length; r++) {
        var row = rows[r] || {};
        var label = row.label != null ? row.label : '';
        var values = Array.isArray(row.values) ? row.values : [];

        html += '<tr>';
        html += '<th scope="row">' + String(label) + '</th>';

        for (var c = 0; c < columns.length - 1; c++) {
          var v = values[c];
          var inch = v == null ? '' : String(v);
          html += '<td data-in="' + inch.replace(/"/g, '&quot;') + '">' + inch + '</td>';
        }

        html += '</tr>';
      }

      html += '</tbody></table></div>';
      mountEl.innerHTML = html;
    }

    function buildTable() {
      if (state.built) return;

      state.columns = safeJsonParse(panel.getAttribute('data-columns'), []);
      state.rows = safeJsonParse(panel.getAttribute('data-rows'), []);

      renderTableInto(preMount, state.columns, state.rows);

      state.built = true;
      setUnit(state.unit);
    }

    function normalizeSizeChart(columns, rows) {
  if (!Array.isArray(columns) || columns.length < 2) return [];

  var mode = getCurrentMode();
  if (!mode) return [];

  var rowMap = mode.rowLabelMap || {};

  var sizeLabels = columns.slice(1).map(function (col) {
    return String(col || '').trim();
  });

  var result = sizeLabels.map(function (sizeLabel) {
    return { size: sizeLabel };
  });

  rows.forEach(function (row) {
    var rawLabel = normalizeLabel(row && row.label);
    var mappedKey = rowMap[rawLabel];
    if (!mappedKey) return;

    var values = Array.isArray(row.values) ? row.values : [];

    for (var i = 0; i < result.length; i++) {
      result[i][mappedKey] = toNumber(values[i]);
    }
  });

  return result;
}

    function metaobjectToChart(metaRef) {
  if (!metaRef || !metaRef.fields) return null;

  var map = {};
  metaRef.fields.forEach(function (f) {
    map[f.key] = f.value;
  });

  if (!map.columns_json || !map.rows_json) return null;

  return {
    columns: JSON.parse(map.columns_json),
    rows: JSON.parse(map.rows_json)
  };
}

async function fetchSiblingFits() {
  const data = JSON.parse(document.getElementById('nfd-fit-family-data')?.textContent || '{}');
  if (!data.familyPrefix) return [];

  const JEANS_FITS = ["00","03","06","16","21","35"];

  const siblingTags = JEANS_FITS
    .filter(code => code !== data.currentFitCode)
    .map(code => `__${data.familyPrefix}${code}`);

  const query = siblingTags.map(function (t) {
    return `tag:${t}`;
  }).join(" OR ");

  const res = await fetch(`https://${window.NFD_STOREFRONT_API.shopDomain}/api/${window.NFD_STOREFRONT_API.version}/graphql.json`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": window.NFD_STOREFRONT_API.token
    },
    body: JSON.stringify({
      query: `
        query($query: String!) {
          products(first: 10, query: $query) {
            nodes {
              handle
              title
              metafield(namespace: "custom", key: "size_chart") {
                reference {
                  ... on Metaobject {
                    fields {
                      key
                      value
                    }
                  }
                }
              }
            }
          }
        }
      `,
      variables: { query: query }
    })
  });

  const json = await res.json();

  return ((json.data && json.data.products && json.data.products.nodes) || [])
    .map(function (p) {
      const chart = metaobjectToChart(p.metafield && p.metafield.reference);
      if (!chart) return null;

      return {
        title: p.title,
        handle: p.handle,
        dataset: normalizeSizeChart(chart.columns, chart.rows)
      };
    })
    .filter(Boolean);
}
async function getBestAlternatives(user, currentResult) {
  const siblings = await fetchSiblingFits();

  const results = siblings
    .map(function (p) {
      const rec = buildRecommendation(p.dataset, user);
      if (!rec) return null;

      return {
        title: p.title,
        handle: p.handle,
        recommendation: rec
      };
    })
    .filter(Boolean);

  if (!results.length) return [];

  var currentAssessment = currentResult && currentResult.assessment ? currentResult.assessment : null;
  var currentConcern = currentAssessment ? currentAssessment.concernArea : null;
  var currentDiffs = currentAssessment && currentAssessment.diffs ? currentAssessment.diffs : {};
  var currentThighDiff = currentDiffs.upperThigh;
  var currentWaistDiff = currentDiffs.waist;

  function materiallyImproves(alt) {
    if (!currentAssessment) return true;

    var altAssessment = alt.recommendation.assessment || {};
    var altDiffs = altAssessment.diffs || {};
    var altThighDiff = altDiffs.upperThigh;
    var altWaistDiff = altDiffs.waist;

    if (currentConcern === 'upperThigh') {
      if (currentThighDiff == null || altThighDiff == null) return false;

      var thighImprovement = altThighDiff - currentThighDiff;

      if (thighImprovement < 0.75) return false;

      if (currentWaistDiff != null && altWaistDiff != null) {
        if (Math.abs(altWaistDiff) > Math.abs(currentWaistDiff) + 0.5) return false;
      }

      return true;
    }

    if (currentConcern === 'waist') {
      if (currentWaistDiff == null || altWaistDiff == null) return false;

      var waistImprovement = Math.abs(currentWaistDiff) - Math.abs(altWaistDiff);
      return waistImprovement >= 0.75;
    }

    var order = {
      strong_match: 0,
      compromise: 1,
      fit_mismatch: 2
    };

    var currentStatus = currentAssessment.status || 'fit_mismatch';
    var altStatus = altAssessment.status || 'fit_mismatch';

    return order[altStatus] < order[currentStatus];
  }

  const filtered = results.filter(materiallyImproves);

  if (!filtered.length) return [];

  filtered.sort(function (a, b) {
    const order = {
      strong_match: 0,
      compromise: 1,
      fit_mismatch: 2
    };

    const aStatus = a.recommendation.assessment?.status || 'fit_mismatch';
    const bStatus = b.recommendation.assessment?.status || 'fit_mismatch';

    if (order[aStatus] !== order[bStatus]) {
      return order[aStatus] - order[bStatus];
    }

    const aWaist = Math.abs(a.recommendation.assessment?.diffs?.waist || 999);
    const bWaist = Math.abs(b.recommendation.assessment?.diffs?.waist || 999);
    if (aWaist !== bWaist) return aWaist - bWaist;

    const aThigh = Math.abs(a.recommendation.assessment?.diffs?.upperThigh || 999);
    const bThigh = Math.abs(b.recommendation.assessment?.diffs?.upperThigh || 999);
    return aThigh - bThigh;
  });

  return filtered.slice(0, 1);
}
window.fetchSiblingFits = fetchSiblingFits;
window.getBestAlternatives = getBestAlternatives;

function buildAltFitReason(alt, currentResult) {
  if (!alt || !alt.recommendation || !alt.recommendation.assessment) return '';

  var assessment = alt.recommendation.assessment;
  var diffs = assessment.diffs || {};
  var waistDiff = diffs.waist;
  var thighDiff = diffs.upperThigh;

  var currentAssessment = currentResult && currentResult.assessment ? currentResult.assessment : null;
  var currentDiffs = currentAssessment && currentAssessment.diffs ? currentAssessment.diffs : {};
  var currentWaistDiff = currentDiffs.waist;
  var currentThighDiff = currentDiffs.upperThigh;

  function improvesThighRoom() {
    if (thighDiff == null || currentThighDiff == null) return false;
    return thighDiff > currentThighDiff + 0.75;
  }

  function keepsSimilarWaist() {
    if (waistDiff == null || currentWaistDiff == null) return false;
    return Math.abs(waistDiff) <= Math.abs(currentWaistDiff) + 0.5;
  }

  if (assessment.status === 'strong_match') {
    if (improvesThighRoom() && keepsSimilarWaist()) {
      return 'More room through the thigh with a similar waist fit.';
    }
    if (improvesThighRoom()) {
      return 'A closer match through the upper thigh.';
    }
    return 'A better overall fit for your measurements.';
  }

  if (assessment.status === 'compromise') {
    if (improvesThighRoom() && keepsSimilarWaist()) {
      return 'More room through the thigh with a similar waist fit.';
    }
    if (improvesThighRoom()) {
      return 'More room through the thigh, though the waist will sit a little differently.';
    }
    if (waistDiff != null && currentWaistDiff != null && Math.abs(waistDiff) < Math.abs(currentWaistDiff)) {
      return 'A closer waist fit — still trimmer through the thigh than your measured jeans.';
    }
    return 'A possible alternative fit, but still not ideal upper thigh fit.';
  }

  if (assessment.status === 'fit_mismatch') {
    if (improvesThighRoom()) {
      return 'More room through the thigh than this fit.';
    }
    return 'Worth considering — but still not an ideal match.';
  }

  return 'Another fit worth considering in this fabric.';
}
function buildAltFitsHtml(alts, currentResult)  {
  if (!alts || !alts.length) return '';

  var items = alts.map(function (alt) {
    var fitName = alt.title.split(' - ')[0];
    var size = alt.recommendation.size;
var reason = buildAltFitReason(alt, currentResult);
    return ''
      + '<a class="nfd-size-rec-alt-fit-card" href="/products/' + escapeHtml(alt.handle) + '">'
        + '<div class="nfd-size-rec-alt-fit-card__top">'
          + '<div class="nfd-size-rec-alt-fit-card__title">'
  + '<span>' + escapeHtml(fitName) + '</span>'
  + '<span class="nfd-size-rec-alt-fit-card__size">' + escapeHtml(size) + '</span>'
+ '</div>'
        + '</div>'
        + '<div class="nfd-size-rec-alt-fit-card__sub">' + escapeHtml(reason) + '</div>'
      + '</a>';
  }).join('');

  return ''
    + '<div class="nfd-size-rec-alt-fit">'
      + '<div class="nfd-size-rec-section-title">You might fit better in</div>'
      + '<div class="nfd-size-rec-alt-fit-grid">' + items + '</div>'
    + '</div>';
}

    function buildRecommendationDataset() {
      var columns = safeJsonParse(panel.getAttribute('data-columns'), []);
      var rows = safeJsonParse(panel.getAttribute('data-rows'), []);
      recState.dataset = normalizeSizeChart(columns, rows);
    }

    function loadMeasurementProfile() {
      try {
        var raw = localStorage.getItem(NFD_SIZE_REC_STORAGE_KEY);
        if (!raw) return null;

        var parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object') return null;

        return parsed;
      } catch (e) {
        return null;
      }
    }

    function findNextSizeUp(chartRows, currentSize) {
  var currentNumeric = numericSizeValue(currentSize);
  if (currentNumeric == null) return null;

  var larger = chartRows
    .filter(function (row) {
      var n = numericSizeValue(row.size);
      return n != null && n > currentNumeric;
    })
    .sort(function (a, b) {
      return numericSizeValue(a.size) - numericSizeValue(b.size);
    });

  return larger.length ? larger[0] : null;
}

function assessFitOutcome(result, chartRows, user) {
  if (!result || !result.measurements || !result.measurements.product || !user) {
    return null;
  }

  var chosen = result.measurements.product;
  var waistDiff = chosen.waist != null && user.waist != null ? chosen.waist - user.waist : null;
  var thighDiff = chosen.upperThigh != null && user.upperThigh != null ? chosen.upperThigh - user.upperThigh : null;

  var nextSize = findNextSizeUp(chartRows, chosen.size);
  var nextWaistDiff = nextSize && nextSize.waist != null && user.waist != null ? nextSize.waist - user.waist : null;
  var nextThighDiff = nextSize && nextSize.upperThigh != null && user.upperThigh != null ? nextSize.upperThigh - user.upperThigh : null;

  function waistOk(diff) {
    return diff != null && diff <= 1 && diff >= -0.5;
  }

if (waistOk(waistDiff) && thighDiff != null && thighDiff >= -0.5 && thighDiff <= 1) {
  return {
    status: 'strong_match',
    summary: 'Waist and upper thigh both land within a normal fit range.',
    concernArea: null,
    alternativeFits: [],
    diffs: {
      waist: waistDiff,
      upperThigh: thighDiff
    }
  };
}

if (waistOk(waistDiff) && thighDiff != null && thighDiff > 3) {
  return {
    status: 'fit_mismatch',
    summary: 'This fit runs much roomier through the upper thigh than your jeans.',
    concernArea: 'upperThigh',
    alternativeFits: ['Weird Guy', 'Super Guy'],
    diffs: {
      waist: waistDiff,
      upperThigh: thighDiff
    }
  };
}

if (waistOk(waistDiff) && thighDiff != null && thighDiff > 1) {
  return {
    status: 'compromise',
    summary: 'The upper thigh will feel roomier than your jeans, while the waist stays close.',
    concernArea: 'upperThigh',
    alternativeFits: [],
    diffs: {
      waist: waistDiff,
      upperThigh: thighDiff
    }
  };
}

if (waistOk(waistDiff) && thighDiff != null && thighDiff < -0.5 && thighDiff >= -1.5) {
  return {
    status: 'compromise',
    summary: 'Closest size in this fit — the upper thigh will feel slightly trimmer than your jeans.',
    concernArea: 'upperThigh',
    alternativeFits: [],
    diffs: {
      waist: waistDiff,
      upperThigh: thighDiff
    }
  };
}

if (
  waistOk(waistDiff) &&
  thighDiff != null &&
  thighDiff < -1.5 &&
  nextSize &&
  nextThighDiff != null &&
  nextThighDiff > thighDiff &&
  nextWaistDiff != null &&
  nextWaistDiff > 1
) {
  return {
    status: 'fit_mismatch',
    summary: 'This fit may feel too slim through the upper thigh for your measurements.',
    concernArea: 'upperThigh',
    alternativeFits: ['Strong Guy', 'Easy Guy'],
    diffs: {
      waist: waistDiff,
      upperThigh: thighDiff
    }
  };
}

return {
  status: 'compromise',
  summary: 'Closest available size in this fit based on your measurements.',
  concernArea: thighDiff != null && (thighDiff < -0.5 || thighDiff > 1) ? 'upperThigh' : null,
  alternativeFits: [],
  diffs: {
    waist: waistDiff,
    upperThigh: thighDiff
  }
};
}
function getModeStorageKey() {
  return isTopsMode() ? 'tops' : 'bottoms';
}

function getEmptyBottomsProfile() {
  return {
    waist: null,
    upperThigh: null,
    frontRise: null,
    backRise: null,
    knee: null,
    legOpening: null,
    inseam: null,
    updatedAt: null
  };
}

function getEmptyTopsProfile() {
  return {
    shoulder: null,
    pitToPit: null,
    sleeveLength: null,
    bodyLength: null,
    updatedAt: null
  };
}

function getCurrentModeProfile(values) {
  if (isTopsMode()) {
    return {
      shoulder: values.shoulder || null,
      pitToPit: values.pitToPit || null,
      sleeveLength: values.sleeveLength || null,
      bodyLength: values.bodyLength || null,
      updatedAt: new Date().toISOString()
    };
  }

  return {
    waist: values.waist || null,
    upperThigh: values.upperThigh || null,
    frontRise: values.frontRise || null,
    backRise: values.backRise || null,
    knee: values.knee || null,
    legOpening: values.legOpening || null,
    inseam: values.inseam || null,
    updatedAt: new Date().toISOString()
  };
}

 function saveMeasurementProfile(profile) {
  try {
    localStorage.setItem(NFD_SIZE_REC_STORAGE_KEY, JSON.stringify(profile));

    document.dispatchEvent(new CustomEvent('nfd:size-profile-save', {
      detail: profile
    }));

    return true;
  } catch (e) {
    return false;
  }
}

function buildStoredProfile(values) {
  var existing = loadMeasurementProfile() || {};

  var bottoms = existing.bottoms && typeof existing.bottoms === 'object'
    ? existing.bottoms
    : (existing.jeans && typeof existing.jeans === 'object' ? existing.jeans : getEmptyBottomsProfile());

  var tops = existing.tops && typeof existing.tops === 'object'
    ? existing.tops
    : getEmptyTopsProfile();

  var modeKey = getModeStorageKey();
  var modeProfile = getCurrentModeProfile(values);
  var now = new Date().toISOString();

  return {
    version: 2,
    unit: 'in',
    bottoms: modeKey === 'bottoms' ? modeProfile : bottoms,
    tops: modeKey === 'tops' ? modeProfile : tops,
    updatedAt: now
  };
}

    function passesWaistGate(productWaist, userWaist) {
      if (productWaist == null || userWaist == null) return false;
      var diff = productWaist - userWaist;
      if (diff > 1) return false;
      if (diff < -0.5) return false;
      return true;
    }

   function passesUpperThighGate(productThigh, userThigh) {
  if (productThigh == null || userThigh == null) return false;
  var diff = productThigh - userThigh;
  if (diff < -2) return false;
  return true;
}

    function buildCandidateScore(sizeRow, user) {
      var score = 0;

      if (sizeRow.waist != null && user.waist != null) {
        score += Math.abs(sizeRow.waist - user.waist) * 100;
      }

      if (sizeRow.upperThigh != null && user.upperThigh != null) {
        score += Math.abs(sizeRow.upperThigh - user.upperThigh) * 70;
      }

      if (sizeRow.frontRise != null && user.frontRise != null) {
        score += Math.abs(sizeRow.frontRise - user.frontRise) * 15;
      }

      if (sizeRow.backRise != null && user.backRise != null) {
        score += Math.abs(sizeRow.backRise - user.backRise) * 15;
      }

      if (sizeRow.knee != null && user.knee != null) {
        score += Math.abs(sizeRow.knee - user.knee) * 12;
      }

      if (sizeRow.legOpening != null && user.legOpening != null) {
        score += Math.abs(sizeRow.legOpening - user.legOpening) * 14;
      }

      if (sizeRow.inseam != null && user.inseam != null) {
        score += Math.abs(sizeRow.inseam - user.inseam) * 8;
      }

      return score;
    }

    function numericSizeValue(sizeLabel) {
      var n = Number(sizeLabel);
      return Number.isFinite(n) ? n : null;
    }

    function compareCandidates(a, b) {
      if (a.score !== b.score) return a.score - b.score;

      var aSize = numericSizeValue(a.size);
      var bSize = numericSizeValue(b.size);

      if (aSize != null && bSize != null) {
        return bSize - aSize;
      }

      return String(b.size).localeCompare(String(a.size));
    }
function getComparisonMeta(label, symbol, tone) {
  return {
    label: label,
    symbol: symbol,
    tone: tone
  };
}

function classifyCoreReason(productVal, userVal, key) {
  if (productVal == null || userVal == null) return null;

  var diff = productVal - userVal;
  var abs = Math.abs(diff);
  var ref = getReferenceLabel();

  if (abs <= 0.25) {
    return getComparisonMeta('matches ' + ref, '≈', 'match');
  }

  if (abs <= 0.5) {
    if (diff > 0) {
      return getComparisonMeta(key === 'waist' ? 'slightly larger' : 'slightly roomier', '↗', 'neutral');
    }
    return getComparisonMeta(key === 'waist' ? 'slightly smaller' : 'slightly trimmer', '↘', 'neutral');
  }

  if (abs > 1.5) {
    return getComparisonMeta(
      key === 'waist'
        ? (diff > 0 ? 'notably larger' : 'notably smaller')
        : (diff > 0 ? 'notably roomier' : 'notably tighter'),
      '⚠',
      'warning'
    );
  }

  if (key === 'waist') {
    return diff > 0
      ? getComparisonMeta('larger', '↗', 'neutral')
      : getComparisonMeta('smaller', '↘', 'neutral');
  }

  return diff > 0
    ? getComparisonMeta('roomier', '↔', 'neutral')
    : getComparisonMeta('trimmer', '↘', 'neutral');
}

function renderComparisonBadge(result, diff) {
  if (!result) return '';

  var delta = '';
  if (diff != null) {
    var sign = diff > 0 ? '+' : '';
    delta = '<span class="nfd-compare-badge__delta">' + sign + diff.toFixed(2) + '"</span>';
  }

  return ''
    + '<span class="nfd-compare-badge nfd-compare-badge--' + escapeHtml(result.tone) + '">'
    +   '<span class="nfd-compare-badge__symbol">' + escapeHtml(result.symbol) + '</span>'
    +   delta
    +   '<span class="nfd-compare-badge__label">' + escapeHtml(result.label) + '</span>'
    + '</span>';
}

function classifyDifference(diff, type) {
  var abs = Math.abs(diff);
  var ref = getReferenceLabel();

  if (abs <= 0.25) {
    return getComparisonMeta('matches ' + ref, '≈', 'match');
  }

  if (type === 'rise') {
    return diff > 0
      ? getComparisonMeta('higher', '↑', 'neutral')
      : getComparisonMeta('lower', '↓', 'neutral');
  }

  if (type === 'width') {
    return diff > 0
      ? getComparisonMeta('wider', '↔', 'neutral')
      : getComparisonMeta('narrower', '↔', 'neutral');
  }

  if (type === 'length') {
    return diff > 0
      ? getComparisonMeta('longer', '↕', 'neutral')
      : getComparisonMeta('shorter', '↕', 'neutral');
  }

  return getComparisonMeta('close to ' + ref, '≈', 'match');
}

    function buildFitComparison(productRow, user) {
  var out = {};

  if (productRow.frontRise != null && user.frontRise != null) {
    var diff = productRow.frontRise - user.frontRise;
    out.frontRise = {
      meta: classifyDifference(diff, 'rise'),
      diff: diff
    };
  }

  if (productRow.backRise != null && user.backRise != null) {
    var diff = productRow.backRise - user.backRise;
    out.backRise = {
      meta: classifyDifference(diff, 'rise'),
      diff: diff
    };
  }

  if (productRow.knee != null && user.knee != null) {
    var diff = productRow.knee - user.knee;
    out.knee = {
      meta: classifyDifference(diff, 'width'),
      diff: diff
    };
  }

  if (productRow.legOpening != null && user.legOpening != null) {
    var diff = productRow.legOpening - user.legOpening;
    out.legOpening = {
      meta: classifyDifference(diff, 'width'),
      diff: diff
    };
  }

  if (productRow.inseam != null && user.inseam != null) {
    var diff = productRow.inseam - user.inseam;
    out.inseam = {
      meta: classifyDifference(diff, 'length'),
      diff: diff
    };
  }

  return out;
}

    function buildFallback(chartRows, user) {
      if (!Array.isArray(chartRows) || !chartRows.length) return null;

      var ranked = chartRows.map(function (row) {
        var waistPenalty = row.waist == null || user.waist == null
          ? 9999
          : Math.abs(row.waist - user.waist) * 100;

        var thighPenalty = row.upperThigh == null || user.upperThigh == null
          ? 9999
          : Math.abs(row.upperThigh - user.upperThigh) * 70;

        var aboveBoost = 0;
        if (row.waist != null && user.waist != null && row.waist >= user.waist) {
          aboveBoost -= 20;
        }

        return {
          row: row,
          size: row.size,
          score: waistPenalty + thighPenalty + aboveBoost
        };
      });

      ranked.sort(compareCandidates);
      return ranked[0] || null;
    }

function buildBottomsRecommendation(chartRows, user) {
  if (!Array.isArray(chartRows) || !chartRows.length) return null;
  if (!user || user.waist == null || user.upperThigh == null) return null;

  var candidates = chartRows
    .map(function (row) {
      var waistOk = passesWaistGate(row.waist, user.waist);
      var thighOk = passesUpperThighGate(row.upperThigh, user.upperThigh);

      if (!waistOk || !thighOk) return null;

      return {
        row: row,
        size: row.size,
        score: buildCandidateScore(row, user)
      };
    })
    .filter(Boolean);

  if (candidates.length) {
    candidates.sort(compareCandidates);

    var chosen = candidates[0];
    var row = chosen.row;
    var assessment = assessFitOutcome({
      size: row.size,
      measurements: {
        user: user,
        product: row
      }
    }, chartRows, user);

    return {
      size: row.size,
      isFallback: false,
      matchQuality: 'strong',
      reasons: {
        waist: classifyCoreReason(row.waist, user.waist, 'waist'),
        upperThigh: classifyCoreReason(row.upperThigh, user.upperThigh, 'upperThigh')
      },
      fitComparison: buildFitComparison(row, user),
      measurements: {
        user: user,
        product: row
      },
      assessment: assessment
    };
  }

  var fallback = buildFallback(chartRows, user);
  if (!fallback) return null;

  var fallbackAssessment = assessFitOutcome({
    size: fallback.row.size,
    measurements: {
      user: user,
      product: fallback.row
    }
  }, chartRows, user);

  return {
    size: fallback.row.size,
    isFallback: true,
    matchQuality: 'fallback',
    reasons: {
      waist: classifyCoreReason(fallback.row.waist, user.waist, 'waist'),
      upperThigh: classifyCoreReason(fallback.row.upperThigh, user.upperThigh, 'upperThigh')
    },
    fitComparison: buildFitComparison(fallback.row, user),
    measurements: {
      user: user,
      product: fallback.row
    },
    assessment: fallbackAssessment
  };
}
function buildRecommendation(chartRows, user) {
  if (!Array.isArray(chartRows) || !chartRows.length) return null;

  if (isBottomsMode()) {
    return buildBottomsRecommendation(chartRows, user);
  }

  if (isTopsMode()) {
    return buildTopsRecommendation(chartRows, user);
  }

  return null;
}
 function passesShoulderGate(productVal, userVal) {
  if (productVal == null || userVal == null) return false;
  var diff = productVal - userVal;
  return diff >= -0.5 && diff <= 1;
}

function passesPitToPitGate(productVal, userVal) {
  if (productVal == null || userVal == null) return false;
  var diff = productVal - userVal;
  return diff >= -1 && diff <= 2;
}

function passesSleeveGate(productVal, userVal) {
  if (productVal == null || userVal == null) return false;
  var diff = productVal - userVal;
  return diff >= -1 && diff <= 1.5;
}

function buildTopCandidateScore(sizeRow, user) {
  var score = 0;

  if (sizeRow.shoulder != null && user.shoulder != null) {
    score += Math.abs(sizeRow.shoulder - user.shoulder) * 110;
  }

  if (sizeRow.pitToPit != null && user.pitToPit != null) {
    score += Math.abs(sizeRow.pitToPit - user.pitToPit) * 95;
  }

  if (sizeRow.sleeveLength != null && user.sleeveLength != null) {
    score += Math.abs(sizeRow.sleeveLength - user.sleeveLength) * 55;
  }

  if (sizeRow.bodyLength != null && user.bodyLength != null) {
    score += Math.abs(sizeRow.bodyLength - user.bodyLength) * 18;
  }

  return score;
}

function assessTopFitOutcome(result, chartRows, user) {
  if (!result || !result.measurements || !result.measurements.product || !user) return null;

  var chosen = result.measurements.product;
  var shoulderDiff = chosen.shoulder != null && user.shoulder != null ? chosen.shoulder - user.shoulder : null;
  var pitDiff = chosen.pitToPit != null && user.pitToPit != null ? chosen.pitToPit - user.pitToPit : null;
  var sleeveDiff = chosen.sleeveLength != null && user.sleeveLength != null ? chosen.sleeveLength - user.sleeveLength : null;

  function shoulderOk(diff) {
    return diff != null && diff >= -0.5 && diff <= 1;
  }

  function pitOk(diff) {
    return diff != null && diff >= -1 && diff <= 2;
  }

  if (shoulderOk(shoulderDiff) && pitOk(pitDiff) && (sleeveDiff == null || (sleeveDiff >= -1 && sleeveDiff <= 1.5))) {
    return {
      status: 'strong_match',
      concernArea: null,
      diffs: {
        shoulder: shoulderDiff,
        pitToPit: pitDiff,
        sleeveLength: sleeveDiff,
        bodyLength: chosen.bodyLength != null && user.bodyLength != null ? chosen.bodyLength - user.bodyLength : null
      }
    };
  }

  if (shoulderOk(shoulderDiff) && pitDiff != null && pitDiff > 2) {
    return {
      status: 'compromise',
      concernArea: 'pitToPit',
      diffs: {
        shoulder: shoulderDiff,
        pitToPit: pitDiff,
        sleeveLength: sleeveDiff,
        bodyLength: chosen.bodyLength != null && user.bodyLength != null ? chosen.bodyLength - user.bodyLength : null
      }
    };
  }

  if (shoulderDiff != null && shoulderDiff < -0.5) {
    return {
      status: 'fit_mismatch',
      concernArea: 'shoulder',
      diffs: {
        shoulder: shoulderDiff,
        pitToPit: pitDiff,
        sleeveLength: sleeveDiff,
        bodyLength: chosen.bodyLength != null && user.bodyLength != null ? chosen.bodyLength - user.bodyLength : null
      }
    };
  }

  return {
    status: 'compromise',
    concernArea: null,
    diffs: {
      shoulder: shoulderDiff,
      pitToPit: pitDiff,
      sleeveLength: sleeveDiff,
      bodyLength: chosen.bodyLength != null && user.bodyLength != null ? chosen.bodyLength - user.bodyLength : null
    }
  };
}

function classifyTopReason(productVal, userVal, key) {
  if (productVal == null || userVal == null) return null;

  var diff = productVal - userVal;
  var abs = Math.abs(diff);

  if (abs <= 0.25) {
    return getComparisonMeta('matches your reference top', '≈', 'match');
  }

  if (key === 'shoulder') {
    return diff > 0
      ? getComparisonMeta('slightly broader', '↔', 'neutral')
      : getComparisonMeta('slightly narrower', '↔', 'neutral');
  }

  if (key === 'pitToPit') {
    return diff > 0
      ? getComparisonMeta('roomier through the body', '↔', 'neutral')
      : getComparisonMeta('trimmer through the body', '↔', 'neutral');
  }

  if (key === 'sleeveLength') {
    return diff > 0
      ? getComparisonMeta('longer sleeve', '↕', 'neutral')
      : getComparisonMeta('shorter sleeve', '↕', 'neutral');
  }

  if (key === 'bodyLength') {
    return diff > 0
      ? getComparisonMeta('longer body', '↕', 'neutral')
      : getComparisonMeta('shorter body', '↕', 'neutral');
  }

  return getComparisonMeta('different from your reference top', '≈', 'neutral');
}

function buildTopFitComparison(productRow, user) {
  var out = {};

  if (productRow.bodyLength != null && user.bodyLength != null) {
    var diff = productRow.bodyLength - user.bodyLength;
    out.bodyLength = {
      meta: classifyDifference(diff, 'length'),
      diff: diff
    };
  }

  return out;
}

function buildTopsRecommendation(chartRows, user) {
  if (!user || user.shoulder == null || user.pitToPit == null || user.sleeveLength == null) return null;

  var candidates = chartRows
    .map(function (row) {
      var shoulderOk = passesShoulderGate(row.shoulder, user.shoulder);
      var pitOk = passesPitToPitGate(row.pitToPit, user.pitToPit);
      var sleeveOk = passesSleeveGate(row.sleeveLength, user.sleeveLength);

      if (!shoulderOk || !pitOk || !sleeveOk) return null;

      return {
        row: row,
        size: row.size,
        score: buildTopCandidateScore(row, user)
      };
    })
    .filter(Boolean);

  if (candidates.length) {
    candidates.sort(compareCandidates);

    var chosen = candidates[0];
    var row = chosen.row;
    var assessment = assessTopFitOutcome({
      size: row.size,
      measurements: {
        user: user,
        product: row
      }
    }, chartRows, user);

    return {
      size: row.size,
      isFallback: false,
      matchQuality: 'strong',
      reasons: {
        shoulder: classifyTopReason(row.shoulder, user.shoulder, 'shoulder'),
        pitToPit: classifyTopReason(row.pitToPit, user.pitToPit, 'pitToPit'),
        sleeveLength: classifyTopReason(row.sleeveLength, user.sleeveLength, 'sleeveLength')
      },
      fitComparison: buildTopFitComparison(row, user),
      measurements: {
        user: user,
        product: row
      },
      assessment: assessment
    };
  }

  var ranked = chartRows.map(function (row) {
    return {
      row: row,
      size: row.size,
      score: buildTopCandidateScore(row, user)
    };
  });

  ranked.sort(compareCandidates);

  if (!ranked.length) return null;

  var fallback = ranked[0];
  var fallbackAssessment = assessTopFitOutcome({
    size: fallback.row.size,
    measurements: {
      user: user,
      product: fallback.row
    }
  }, chartRows, user);

  return {
    size: fallback.row.size,
    isFallback: true,
    matchQuality: 'fallback',
    reasons: {
      shoulder: classifyTopReason(fallback.row.shoulder, user.shoulder, 'shoulder'),
      pitToPit: classifyTopReason(fallback.row.pitToPit, user.pitToPit, 'pitToPit'),
      sleeveLength: classifyTopReason(fallback.row.sleeveLength, user.sleeveLength, 'sleeveLength')
    },
    fitComparison: buildTopFitComparison(fallback.row, user),
    measurements: {
      user: user,
      product: fallback.row
    },
    assessment: fallbackAssessment
  };
}
function validateMeasurementInput(values) {
  var errors = {};
  var required = getRequiredFields();

  required.forEach(function (key) {
    if (toNumber(values[key]) == null || toNumber(values[key]) <= 0) {
      errors[key] = 'Required';
    }
  });

  return {
    isValid: Object.keys(errors).length === 0,
    errors: errors
  };
}

function normalizeUserMeasurements(rawValues) {
  function norm(v) {
    var n = toNumber(v);
    return n == null ? null : n;
  }

  return {
    waist: norm(rawValues.waist),
    upperThigh: norm(rawValues.upperThigh),
    frontRise: norm(rawValues.frontRise),
    backRise: norm(rawValues.backRise),
    knee: norm(rawValues.knee),
    legOpening: norm(rawValues.legOpening),
    inseam: norm(rawValues.inseam),

    shoulder: norm(rawValues.shoulder),
    pitToPit: norm(rawValues.pitToPit),
    sleeveLength: norm(rawValues.sleeveLength),
    bodyLength: norm(rawValues.bodyLength)
  };
}
    

    function showRecStep(stepNum) {
      recSteps.forEach(function (step) {
        var is = String(stepNum) === step.getAttribute('data-rec-step');
        step.hidden = !is;
        step.classList.toggle('is-active', is);
      });

      recProgressItems.forEach(function (item) {
        var isActive = String(stepNum) === item.getAttribute('data-rec-progress');
        item.classList.toggle('is-active', isActive);
      });

      if (recResultWrap) recResultWrap.hidden = true;
    }

    recProgressItems.forEach(function (item) {
      item.addEventListener('click', function () {
        var step = item.getAttribute('data-rec-progress');
        if (!step) return;
        showRecStep(step);
      });

      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var step = item.getAttribute('data-rec-progress');
          if (!step) return;
          showRecStep(step);
        }
      });
    });

    function clearRecErrors() {
      recErrorEls.forEach(function (el) {
        el.textContent = '';
      });
    }

function resetAdditionalMeasurements() {
  var required = getRequiredFields();

  recInputEls.forEach(function (input) {
    var key = input.getAttribute('data-rec-input');
    if (required.indexOf(key) !== -1) return;
    input.value = '';
  });

  if (recState.profile) {
    var modeKey = getModeStorageKey();
    var saved = recState.profile[modeKey];

    if (saved && typeof saved === 'object') {
      Object.keys(saved).forEach(function (key) {
        if (required.indexOf(key) !== -1) return;
        if (key === 'updatedAt') return;
        saved[key] = null;
      });

      saved.updatedAt = new Date().toISOString();
      recState.profile.updatedAt = new Date().toISOString();
      saveMeasurementProfile(recState.profile);
    }
  }

  clearRecErrors();
}
    function getRecRawValues() {
      var out = {};
      recInputEls.forEach(function (input) {
        out[input.getAttribute('data-rec-input')] = input.value;
      });
      return out;
    }

   function fillRecInputsFromProfile(profile) {
  if (!profile) return;

  var modeKey = getModeStorageKey();
  var saved = profile[modeKey];

  if (!saved) return;

  recInputEls.forEach(function (input) {
    var key = input.getAttribute('data-rec-input');
    input.value = saved[key] != null ? saved[key] : '';
  });
}
function getVisualTone(meta) {
  if (!meta || !meta.tone) return 'neutral';
  return meta.tone;
}

function getVisualLabel(meta, fallback) {
  if (!meta || !meta.label) return fallback || '';
  return meta.label;
}

function buildVisualBadge(label, meta, extraClass) {
  if (!meta) return '';

  return ''
    + '<div class="nfd-size-rec-visual-badge nfd-size-rec-visual-badge--' + escapeHtml(getVisualTone(meta)) + (extraClass ? ' ' + extraClass : '') + '">'
    +   '<span class="nfd-size-rec-visual-badge__label">' + escapeHtml(label) + '</span>'
    +   '<span class="nfd-size-rec-visual-badge__value">' + escapeHtml(getVisualLabel(meta)) + '</span>'
    + '</div>';
}


function getVisualStateClass(meta) {
  if (!meta || !meta.tone) return 'neutral';
  return meta.tone;
}

function buildVisualLineClass(baseClass, meta) {
  return baseClass + ' ' + getVisualStateClass(meta);
}

function buildResultHtml(result, displayUnit) {
  if (!result) {
    return '<p class="nfd-size-rec-empty">No size suggestion is available for this product.</p>';
  }

  var reasons = result.reasons || {};
  var measurements = result.measurements || {};
  var user = measurements.user || {};
  var product = measurements.product || {};
  var assessment = result.assessment || {};
  var fitComparison = result.fitComparison || {};
  var refLabel = getReferenceLabel();
  var isBottoms = isBottomsMode();
  var isTops = isTopsMode();

  var parts = splitProductTitle(productTitle);
  var fitName = parts.fit || '';
  var fabricName = normalizeFabricLabel(parts.fabric || '');

  var titleLead = '';

  if (fabricName && fitName) {
    if (assessment.status === 'strong_match') {
      titleLead = 'In ' + fabricName + ', your best size in ' + fitName + ' is ';
    } else {
      titleLead = 'In ' + fabricName + ', the closest size for you in ' + fitName + ' is ';
    }
  } else {
    titleLead = 'Based on your measurements, the closest size is ';
  }

  function buildSummary() {
    if (isBottoms) {
      var thighDiff = assessment.diffs && assessment.diffs.upperThigh != null
        ? assessment.diffs.upperThigh
        : null;

      if (assessment.status === 'strong_match') {
        return 'Waist and upper thigh both land close to your reference pair.';
      }

      if (assessment.status === 'compromise') {
        if (assessment.concernArea === 'upperThigh') {
          if (thighDiff != null && thighDiff < -0.5) {
            return 'This is the closest size in this fit, but the upper thigh will feel trimmer than your jeans.';
          }
          if (thighDiff != null && thighDiff > 1) {
            return 'This size works in the waist, but the upper thigh will feel roomier than your jeans.';
          }
        }
        return 'This is the closest size in this fit based on your measurements.';
      }

      if (assessment.status === 'fit_mismatch') {
        if (thighDiff != null && thighDiff < -1.5) {
          return 'This fit may be too slim in the upper thigh for your measurements.';
        }
        if (thighDiff != null && thighDiff > 2) {
          return 'This fit runs roomier through the upper thigh than your jeans.';
        }
        return 'This fit is not the closest match for your measurements.';
      }

      return 'Based on your jeans measurements compared against this size chart.';
    }

    if (isTops) {
      var shoulderDiff = assessment.diffs && assessment.diffs.shoulder != null
        ? assessment.diffs.shoulder
        : null;
      var pitDiff = assessment.diffs && assessment.diffs.pitToPit != null
        ? assessment.diffs.pitToPit
        : null;

      if (assessment.status === 'strong_match') {
        return 'Shoulder, body, and sleeve sit close to your reference top.';
      }

      if (assessment.status === 'compromise') {
        if (assessment.concernArea === 'pitToPit' && pitDiff != null && pitDiff > 0) {
          return 'This is the closest size, but it may feel roomier through the body than your reference top.';
        }
        return 'This is the closest match based on your reference top.';
      }

      if (assessment.status === 'fit_mismatch') {
        if (assessment.concernArea === 'shoulder' && shoulderDiff != null && shoulderDiff < 0) {
          return 'This size may feel too narrow through the shoulders compared to your reference top.';
        }
        return 'This fit is not the closest match for your measurements.';
      }

      return 'Based on your reference top measurements compared against this size chart.';
    }

    return '';
  }

  function buildKeyBullets() {
    var items = [];

    if (isBottoms) {
      if (reasons.waist) {
        var waistDiff = product.waist != null && user.waist != null ? product.waist - user.waist : null;
        items.push(
          '<li><strong>Waist:</strong> ' + renderComparisonBadge(reasons.waist, waistDiff) + '</li>'
        );
      }

      if (reasons.upperThigh) {
        var thighDiff = product.upperThigh != null && user.upperThigh != null ? product.upperThigh - user.upperThigh : null;
        items.push(
          '<li><strong>Upper thigh:</strong> ' + renderComparisonBadge(reasons.upperThigh, thighDiff) + '</li>'
        );
      }
    }

    if (isTops) {
      if (reasons.shoulder) {
        var shoulderDiff = product.shoulder != null && user.shoulder != null ? product.shoulder - user.shoulder : null;
        items.push(
          '<li><strong>Shoulder:</strong> ' + renderComparisonBadge(reasons.shoulder, shoulderDiff) + '</li>'
        );
      }

      if (reasons.pitToPit) {
        var pitDiff = product.pitToPit != null && user.pitToPit != null ? product.pitToPit - user.pitToPit : null;
        items.push(
          '<li><strong>Pit to pit:</strong> ' + renderComparisonBadge(reasons.pitToPit, pitDiff) + '</li>'
        );
      }
    }

    if (!items.length) return '';
    return '<div class="nfd-size-rec-section"><ul>' + items.join('') + '</ul></div>';
  }

  function buildShapeCutSection() {
    var fitItems = '';

    Object.keys(fitComparison).forEach(function (key) {
      var item = fitComparison[key];
      if (!item || !item.meta) return;

      fitItems += '<li><strong>' + escapeHtml((getCompareLabels()[key]) || key) + ':</strong> '
        + renderComparisonBadge(item.meta, item.diff)
        + '</li>';
    });

    if (!fitItems) return '';

    return ''
      + '<div class="nfd-size-rec-section">'
      +   '<div class="nfd-size-rec-section-title">Shape & cut comparison</div>'
      +   '<ul>' + fitItems + '</ul>'
      + '</div>';
  }

  var detailData = [];

  if (isBottoms) {
    detailData = [
      ['Waist', user.waist, product.waist],
      ['Upper thigh', user.upperThigh, product.upperThigh],
      ['Front rise', user.frontRise, product.frontRise],
      ['Back rise', user.backRise, product.backRise],
      ['Knee', user.knee, product.knee],
      ['Leg opening', user.legOpening, product.legOpening],
      ['Inseam', user.inseam, product.inseam]
    ];
  } else if (isTops) {
    detailData = [
      ['Shoulder', user.shoulder, product.shoulder],
      ['Pit to pit', user.pitToPit, product.pitToPit],
      ['Sleeve length', user.sleeveLength, product.sleeveLength],
      ['Body length', user.bodyLength, product.bodyLength]
    ];
  }

  var detailRows = detailData.map(function (row) {
    return '<tr>'
      + '<th>' + escapeHtml(row[0]) + '</th>'
      + '<td>' + escapeHtml(formatMeasurement(row[1], displayUnit)) + '</td>'
      + '<td>' + escapeHtml(formatMeasurement(row[2], displayUnit)) + '</td>'
      + '</tr>';
  }).join('');

  var hemmingHtml = '';
  var inseamDiff = product.inseam != null && user.inseam != null
    ? product.inseam - user.inseam
    : null;

  if (isBottoms && inseamDiff != null && inseamDiff >= 2) {
    hemmingHtml =
      '<div class="nfd-size-rec-hemming">'
      + 'The inseam on this size runs about +' + Math.round(inseamDiff) + '" longer than ' + refLabel + '. '
      + 'We\'ll hem them to your preferred length at no charge. '
      + '<a href="https://nakedandfamousdenim.com/pages/customization" class="nfd-size-chart-help-link" target="_blank" rel="noopener">How hemming works</a>.'
      + '</div>';
  }

var fitVisualData = window.NFDSizeVisual && typeof window.NFDSizeVisual.getFitVisualData === 'function'
  ? window.NFDSizeVisual.getFitVisualData()
  : null;

var hasVisual = !!(fitVisualData && fitVisualData.drawing);

var visualHtml = hasVisual
  ? ''
    + '<div class="nfd-size-rec-visual-wrap">'
    +   '<div class="nfd-size-rec-visual-head">'
    +     '<span class="nfd-size-rec-visual-head__lead">' + escapeHtml(titleLead) + '</span>'
    +     '<strong class="nfd-size-rec-visual-head__size">' + escapeHtml(result.size) + '</strong>'
    +   '</div>'


    +   '<div data-nfd-visual-root></div>'
    + '</div>'
  : '';

var fallbackHeader = !hasVisual
  ? ''
    + '<div class="nfd-size-rec-result-head">'
    +   '<div class="nfd-size-rec-result-title">'
    +     '<span class="nfd-size-rec-result-title__lead">' + escapeHtml(titleLead) + '</span>'
    +     '<strong class="nfd-size-rec-result-title__size">' + escapeHtml(result.size) + '</strong>'
    +   '</div>'
    +   '<div class="nfd-size-rec-result-sub">' + escapeHtml(buildSummary()) + '</div>'
    + '</div>'
  : '';

var summaryUnderVisual = hasVisual
  ? '<div class="nfd-size-rec-summary-under">' + escapeHtml(buildSummary()) + '</div>'
  : '';

return ''
  + '<div class="nfd-size-rec-result">'

  +   fallbackHeader

  +   visualHtml
  +   summaryUnderVisual

    +   buildKeyBullets()

    +   buildShapeCutSection()

    +   '<details class="nfd-size-rec-details">'
    +     '<summary>View all measurements</summary>'
    +     '<table class="nfd-size-rec-table">'
    +       '<thead>'
    +         '<tr>'
    +           '<th>Measurement</th>'
    +           '<th>' + escapeHtml(isTops ? 'Your reference top' : 'Your jeans') + '</th>'
    +           '<th>' + escapeHtml(productTitle) + '</th>'
    +         '</tr>'
    +       '</thead>'
    +       '<tbody>' + detailRows + '</tbody>'
    +     '</table>'
    +   '</details>'

    +   hemmingHtml

    + '</div>';
}


function buildInlineMemoHtml(result) {
  if (!result) return '';

  return ''
    + '<div class="nfd-size-rec-inline-card">'
    +   '<div class="nfd-size-rec-inline-head">'
    +     '<div class="nfd-size-rec-result-title">Suggested size: <strong>' + escapeHtml(result.size) + '</strong></div>'
    +     '<button type="button" class="nfd-size-rec-inline-info" data-rec-inline-open="why" aria-label="View size suggestion details">𝐢</button>'
    +   '</div>'
    + '</div>';
}
    function renderInlineMemo(result) {
      if (!recInlineMemo) return;

      if (!recState.supported || !result) {
        recInlineMemo.hidden = true;
        recInlineMemo.innerHTML = '';
        updateRecTriggerLabel(false);
        return;
      }

      recInlineMemo.innerHTML = buildInlineMemoHtml(result);
      recInlineMemo.hidden = false;
      updateRecTriggerLabel(true);
    }

    function computeSavedRecommendation() {
  if (!recState.dataset || !recState.profile) return null;

  var modeKey = getModeStorageKey();
  var saved = recState.profile[modeKey];

  if (!saved) return null;

  return buildRecommendation(recState.dataset, saved);
}

function submitRecommendation() {
  clearRecErrors();

  var rawValues = getRecRawValues();
  var validation = validateMeasurementInput(rawValues);

  if (!validation.isValid) {
    Object.keys(validation.errors).forEach(function (key) {
      var errEl = recDialog.querySelector('[data-rec-error="' + key + '"]');
      if (errEl) errEl.textContent = validation.errors[key];
    });
    showRecStep(2);
    return;
  }

  document.dispatchEvent(new CustomEvent('nfd:find-my-size-submit'));

  var normalized = normalizeUserMeasurements(rawValues);
  var result = buildRecommendation(recState.dataset, normalized);

  recState.recommendation = result;
  recState.profile = buildStoredProfile(normalized);
  saveMeasurementProfile(recState.profile);

  recResultWrap.innerHTML = buildResultHtml(result, 'in');
  recResultWrap.hidden = false;
  var visualRoot = recResultWrap.querySelector('[data-nfd-visual-root]');
if (visualRoot && window.NFDSizeVisual) {
  window.NFDSizeVisual.mount(visualRoot, result, {
    mode: isTopsMode() ? 'tops' : 'bottoms'
  });
}



recSteps.forEach(function (step) {
  step.hidden = true;
});

if (isBottomsMode() && result && result.assessment && ['compromise', 'fit_mismatch'].includes(result.assessment.status)) {
  var saved = recState.profile && recState.profile.bottoms;

  if (saved) {
    getBestAlternatives(saved, result).then(function (alts) {
      var existingAlt = recResultWrap.querySelector('.nfd-size-rec-alt-fit');
      if (existingAlt) existingAlt.remove();

      if (alts && alts.length) {
        var table = recResultWrap.querySelector('.nfd-size-rec-details');
        if (table) {
          table.insertAdjacentHTML('beforebegin', buildAltFitsHtml(alts, result));

          var altBlock = recResultWrap.querySelector('.nfd-size-rec-alt-fit');
          if (altBlock) {
            requestAnimationFrame(function () {
              altBlock.classList.add('is-visible');
            });
          }
        }
      }
    });
  }
}
  renderInlineMemo(result);
}

buildRecommendationDataset();
updateRecommendationVisibility();
updateModeUi();

recState.profile = loadMeasurementProfile();

    if (recState.supported && recState.profile) {
      fillRecInputsFromProfile(recState.profile);
      renderInlineMemo(computeSavedRecommendation());
    } else {
      updateRecTriggerLabel(false);
    }

    if (!window.__nfdFindMySizeClickBound) {
  window.__nfdFindMySizeClickBound = true;

  document.addEventListener('click', function (e) {
    var recA = e.target && e.target.closest && e.target.closest('.nfd-size-rec-toggle');
    if (recA) {
      e.preventDefault();

      if (!recState.supported) {
        return;
      }

      closeChart();

      document.dispatchEvent(new CustomEvent('nfd:find-my-size-open'));

      if (recState.profile) {
        fillRecInputsFromProfile(recState.profile);
        showRecStep(2);
      } else {
        showRecStep(1);
      }

      recA.setAttribute('aria-expanded', 'true');
      openRecDrawer();
      lockPageScroll();
      return;
    }

var whyBtn = e.target && e.target.closest && e.target.closest('[data-rec-inline-open="why"]');
if (whyBtn) {
  e.preventDefault();

  if (!recState.supported) {
    return;
  }

  closeChart();

  if (recState.profile) {
    fillRecInputsFromProfile(recState.profile);
  }

  var result = computeSavedRecommendation();

  if (result) {
    recResultWrap.innerHTML = buildResultHtml(result, 'in');
    recResultWrap.hidden = false;

    recSteps.forEach(function (step) {
      step.hidden = true;
    });

    var visualRoot = recResultWrap.querySelector('[data-nfd-visual-root]');
    if (visualRoot && window.NFDSizeVisual) {
      window.NFDSizeVisual.mount(visualRoot, result, {
        mode: isTopsMode() ? 'tops' : 'bottoms'
      });
    }

    if (isBottomsMode() && result.assessment && ['compromise', 'fit_mismatch'].includes(result.assessment.status)) {
      var saved = recState.profile && recState.profile.bottoms;

      if (saved) {
        getBestAlternatives(saved, result).then(function (alts) {
          var existingAlt = recResultWrap.querySelector('.nfd-size-rec-alt-fit');
          if (existingAlt) existingAlt.remove();

          if (alts && alts.length) {
            var table = recResultWrap.querySelector('.nfd-size-rec-details');
            if (table) {
              table.insertAdjacentHTML('beforebegin', buildAltFitsHtml(alts, result));

              var altBlock = recResultWrap.querySelector('.nfd-size-rec-alt-fit');
              if (altBlock) {
                requestAnimationFrame(function () {
                  altBlock.classList.add('is-visible');
                });
              }
            }
          }
        });
      }
    }
  }

  openRecDrawer();
  lockPageScroll();
  return;
}

    var chartA = e.target && e.target.closest && e.target.closest('.nfd-size-chart-toggle');
    if (chartA) {
      e.preventDefault();

      var willOpen = panel.hidden;
      panel.hidden = !willOpen;

      chartA.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

      if (willOpen) {
        state.built = false;
        buildTable();
      }

      return;
    }
  });
}

    recDialog.addEventListener('click', function (e) {
      var nextBtn = e.target.closest('[data-next-step]');
      if (nextBtn) {
        e.preventDefault();
        showRecStep(nextBtn.getAttribute('data-next-step'));
        return;
      }

      var resetBtn = e.target.closest('[data-rec-reset="additional"]');
      if (resetBtn) {
        e.preventDefault();
        resetAdditionalMeasurements();
        return;
      }

      var prevBtn = e.target.closest('[data-prev-step]');
      if (prevBtn) {
        e.preventDefault();
        showRecStep(prevBtn.getAttribute('data-prev-step'));
        return;
      }

      
      var submitBtn = e.target.closest('[data-rec-submit]');
      if (submitBtn) {
        e.preventDefault();
        submitRecommendation();
      }
    });

function refreshSizeUi() {
  refreshLiveRefs();

  if (!panel || !preMount || !recDialog) return;

  state.built = false;
  closeChart();
  buildRecommendationDataset();
  updateRecommendationVisibility();
  updateModeUi();
  renderInlineMemo(computeSavedRecommendation());
}

    document.addEventListener('variant:change', function () {
      setTimeout(refreshSizeUi, 0);
    });

    document.addEventListener('product:variant-change', function () {
      setTimeout(refreshSizeUi, 0);
    });

    var form = panel.closest('form');
    if (form) {
      form.addEventListener('change', function () {
        setTimeout(refreshSizeUi, 0);
      });
    }

    recInputEls.forEach(function (input) {
      input.addEventListener('wheel', function (e) {
        if (document.activeElement === input) {
          e.preventDefault();
        }
      }, { passive: false });
    });

    unitBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var next = b.getAttribute('data-unit');
        if (!next) return;
        setUnit(next);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFindMySize);
  } else {
    initFindMySize();
  }
})();